// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* *
{
  font-family: "Poppins",sans-serif!important;
} */

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  /* font-family: "system-ui"; */
  color: #363157 !important;
}


/* .MuiMenu-root .MuiMenuItem-root
{
font-family: "system-ui";
} */

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

 
::-webkit-scrollbar-thumb {
  background: #be8976a9;
  border-radius: 1rem;
  border: 1px solid brown;
}

.custom-textfield {
  border-bottom: 2px solid red;
}

.table-container {
  margin: 20px;
}

.pagination-number ul li button {
  border-radius: 5px;
  font-size: 12px;
  min-width: 25px;
  height: 25px;
  border: 0.5px solid #e2e2e2;
  color: #be8976;
}
.pagination-number .MuiPaginationItem-previousNext,
.pagination-number .MuiPaginationItem-firstLast {
  border: none !important;
}
.custom-menu-item {
  height: 40px; /* Set your desired height value */
}
.pagination-number .Mui-selected {
  background-color: #be8976 !important;
  color: white;
}

.login-form .MuiInputBase-formControl::after {
  content: "";
  border-bottom: 1px solid #c1c7cd;
  border-radius: 4px;
}

.login-form .MuiInputBase-formControl::before {
  content: "";
  border-bottom: 1px solid #c1c7cd;
  border-radius: 4px;
}

.flex-item-box {
  border-radius: 6px;
  background-color: #f8f7ff;
  border: 1px solid #36315714;
  padding: 12px 8px 12px 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column !important;
}

.hover-zoom:hover {
  transform: scale(1.04);
  cursor: pointer;
  border: 1px solid #8e88b5;
  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.12);
}

.hover-zoom-slabreach:hover {
  transform: scale(1.04);
  border: 1px solid #8e88b5;
  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.12);
}

.activecaretup::before {
  content: "";
  position: absolute;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #1b76e0;
  top: 0px;
}

@keyframes bellRing {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(15deg);
  }
  50% {
    transform: rotate(-15deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.bell-ring-animation {
  animation: bellRing 0.7s ease-in-out infinite;
}

.custom-tooltip {
  border-radius: 5px;
  border: 1px solid #d5d5d5;
  background: #fbfafa;
  box-shadow: 0px 4.73479px 17.04523px -2.36739px rgba(0, 0, 0, 0.1);
}

.custom-tooltip .MuiGrid-root {
  font-size: 14px;
}

.recharts-legend-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 7px !important;
  font-size: 15px;
  width: 100% !important;
  position: unset !important;
}

.recharts-surface {
  overflow: visible;
}

/* .recharts-tooltip-wrapper {
  position: relative;
}

.recharts-tooltip-wrapper:after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-top: none;
  border-bottom: 6px solid #fff; 
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
}  */

.tabel-data-padding th,
.tabel-data-padding td {
  padding: 8px;
  font-size: 12px !important;
  color: #363157 !important;
}

.customerpageinnerbackground {
  background: rgba(54, 49, 87, 0.06);
  border-radius: 5px;
  border: 1px solid rgba(54, 49, 87, 0.3);
}

.customerpageinnerbackground1 {
  background: rgba(54, 49, 87, 0.06);
  border-radius: 5px;
  border: 1px solid rgba(54, 49, 87, 0.3);
}
.tableinnerrow-head th {
  padding: 15px 8px;
  color: #363157 !important;
}

.customerpageinnerbackground1 input {
  border-left: 1px solid rgba(54, 49, 87, 0.3);
  padding-left: 10px;
}

.graph-scroll {
  overflow: scroll;
  /* display: -webkit-box; */
  flex-wrap: nowrap;
  /* padding: 35px; */
  overflow-x: hidden;
  overflow-y: hidden;
}
.graph-scroll:hover {
  overflow-x: scroll;
}

.MuiPopover-paper::-webkit-scrollbar {
  max-width: 8px;
}

.graph-scroll::-webkit-scrollbar {
  max-height: 10px;
}
.graph-scroll::-webkit-scrollbar-thumb,
.MuiPopover-paper::-webkit-scrollbar-thumb {
  background: rgba(190, 137, 118, 0.4);
  border-radius: 10px;
}

.Material-Tbale-padding-apply .MuiIconButton-root {
  padding: 0px;
  margin: 8px;
}

.Material-Tbale-padding-apply-disable .MuiIconButton-root {
  padding: 0px;
  margin: 8px;
  pointer-events: none;
}

.loader-overlay-spinner ._loading_overlay_overlay {
  position: fixed;
  z-index: 9999;
}
/* .end{
  display: flex;
  margin-left: 30px;
  

} */
.boxing {
  background-color: #fafafa;
  margin-top: 20px;
  padding: 16px;
  width: 100%;
  padding-top: 12px;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
}
.boxing1 {
  max-width: 1000px;
}

.buttonclr {
  border-radius: 6px;
  background-color: #f7cd60;
  align-items: center;
  width: 170px;
  height: 32px;
  border: none;
  color: white;
}
.detail {
  display: flex;
}
.answer {
  font-weight: bold;
}
textarea {
  height: 80px;
  width: 100% !important;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f2f2f2;
  font-size: medium;
}
textarea::placeholder {
  padding: 5px;
}
.truncate-text::after {
  content: "...";
}

.myCustomList::-webkit-scrollbar {
  max-width: 8px;
}

.myCustomList::-webkit-scrollbar-thumb {
  background: rgba(190, 137, 118, 0.4);
  border-radius: 10px;
}

.MuiBadge-colorPrimary {
  color: white !important;
  background-color: #be8976 !important;
  padding: 2px 2px !important;
  font-size: 10.3px !important;
}

.tool-tip {
  position: relative;
  display: inline-block;
}

.tool-tip-delay {
  position: relative;
  display: inline-block;
}

.tool-tip-delay .tooltip-text-delay {
  visibility: hidden;
  width: max-content;
  background-color: #e9d2c9;
  color: #363157;
  text-align: center;
  border-radius: 3px;
  padding: 5px 10px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  transform: translate(-50%, 50%);
  top: 22px;
  left: 55px;
}

span.tooltip-text-delay::before {
  width: 0px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #e9d2c9;
  content: "";
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.tool-tip-delay:hover .tooltip-text-delay {
  visibility: visible;
}

.tool-tip-delay .tooltip-graph {
  transform: translate(0);
  position: fixed;
  right: 0px;
  left: 0px;
  top: 30px;
  z-index: 9999;
  width: 75%;
}

.circle-line
{
  top: 15px;
  width: 2px;
  background: rgb(211, 218, 230);
  height: calc(100% + 24px);
  position: absolute;
  left: 17px;
}

div.checking:last-of-type {
  height: 50% !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/app.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;EACE,SAAS;EACT,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;;AAGA;;;GAGG;;AAEH;EACE,aAAa;EACb,cAAc;AAChB;;;AAGA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,YAAY,EAAE,kCAAkC;AAClD;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;IAaI;;AAEJ;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;AACA;;;;;GAKG;AACH;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,SAAS;EACT,SAAS;EACT,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* *\n{\n  font-family: \"Poppins\",sans-serif!important;\n} */\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  /* font-family: \"system-ui\"; */\n  color: #363157 !important;\n}\n\n\n/* .MuiMenu-root .MuiMenuItem-root\n{\nfont-family: \"system-ui\";\n} */\n\n::-webkit-scrollbar {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n\n \n::-webkit-scrollbar-thumb {\n  background: #be8976a9;\n  border-radius: 1rem;\n  border: 1px solid brown;\n}\n\n.custom-textfield {\n  border-bottom: 2px solid red;\n}\n\n.table-container {\n  margin: 20px;\n}\n\n.pagination-number ul li button {\n  border-radius: 5px;\n  font-size: 12px;\n  min-width: 25px;\n  height: 25px;\n  border: 0.5px solid #e2e2e2;\n  color: #be8976;\n}\n.pagination-number .MuiPaginationItem-previousNext,\n.pagination-number .MuiPaginationItem-firstLast {\n  border: none !important;\n}\n.custom-menu-item {\n  height: 40px; /* Set your desired height value */\n}\n.pagination-number .Mui-selected {\n  background-color: #be8976 !important;\n  color: white;\n}\n\n.login-form .MuiInputBase-formControl::after {\n  content: \"\";\n  border-bottom: 1px solid #c1c7cd;\n  border-radius: 4px;\n}\n\n.login-form .MuiInputBase-formControl::before {\n  content: \"\";\n  border-bottom: 1px solid #c1c7cd;\n  border-radius: 4px;\n}\n\n.flex-item-box {\n  border-radius: 6px;\n  background-color: #f8f7ff;\n  border: 1px solid #36315714;\n  padding: 12px 8px 12px 10px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column !important;\n}\n\n.hover-zoom:hover {\n  transform: scale(1.04);\n  cursor: pointer;\n  border: 1px solid #8e88b5;\n  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.12);\n}\n\n.hover-zoom-slabreach:hover {\n  transform: scale(1.04);\n  border: 1px solid #8e88b5;\n  box-shadow: 0px 4px 27px 0px rgba(0, 0, 0, 0.12);\n}\n\n.activecaretup::before {\n  content: \"\";\n  position: absolute;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #1b76e0;\n  top: 0px;\n}\n\n@keyframes bellRing {\n  0% {\n    transform: rotate(0deg);\n  }\n  25% {\n    transform: rotate(15deg);\n  }\n  50% {\n    transform: rotate(-15deg);\n  }\n  75% {\n    transform: rotate(10deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.bell-ring-animation {\n  animation: bellRing 0.7s ease-in-out infinite;\n}\n\n.custom-tooltip {\n  border-radius: 5px;\n  border: 1px solid #d5d5d5;\n  background: #fbfafa;\n  box-shadow: 0px 4.73479px 17.04523px -2.36739px rgba(0, 0, 0, 0.1);\n}\n\n.custom-tooltip .MuiGrid-root {\n  font-size: 14px;\n}\n\n.recharts-legend-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 7px !important;\n  font-size: 15px;\n  width: 100% !important;\n  position: unset !important;\n}\n\n.recharts-surface {\n  overflow: visible;\n}\n\n/* .recharts-tooltip-wrapper {\n  position: relative;\n}\n\n.recharts-tooltip-wrapper:after {\n  content: \"\";\n  position: absolute;\n  border: 6px solid transparent;\n  border-top: none;\n  border-bottom: 6px solid #fff; \n  top: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n}  */\n\n.tabel-data-padding th,\n.tabel-data-padding td {\n  padding: 8px;\n  font-size: 12px !important;\n  color: #363157 !important;\n}\n\n.customerpageinnerbackground {\n  background: rgba(54, 49, 87, 0.06);\n  border-radius: 5px;\n  border: 1px solid rgba(54, 49, 87, 0.3);\n}\n\n.customerpageinnerbackground1 {\n  background: rgba(54, 49, 87, 0.06);\n  border-radius: 5px;\n  border: 1px solid rgba(54, 49, 87, 0.3);\n}\n.tableinnerrow-head th {\n  padding: 15px 8px;\n  color: #363157 !important;\n}\n\n.customerpageinnerbackground1 input {\n  border-left: 1px solid rgba(54, 49, 87, 0.3);\n  padding-left: 10px;\n}\n\n.graph-scroll {\n  overflow: scroll;\n  /* display: -webkit-box; */\n  flex-wrap: nowrap;\n  /* padding: 35px; */\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.graph-scroll:hover {\n  overflow-x: scroll;\n}\n\n.MuiPopover-paper::-webkit-scrollbar {\n  max-width: 8px;\n}\n\n.graph-scroll::-webkit-scrollbar {\n  max-height: 10px;\n}\n.graph-scroll::-webkit-scrollbar-thumb,\n.MuiPopover-paper::-webkit-scrollbar-thumb {\n  background: rgba(190, 137, 118, 0.4);\n  border-radius: 10px;\n}\n\n.Material-Tbale-padding-apply .MuiIconButton-root {\n  padding: 0px;\n  margin: 8px;\n}\n\n.Material-Tbale-padding-apply-disable .MuiIconButton-root {\n  padding: 0px;\n  margin: 8px;\n  pointer-events: none;\n}\n\n.loader-overlay-spinner ._loading_overlay_overlay {\n  position: fixed;\n  z-index: 9999;\n}\n/* .end{\n  display: flex;\n  margin-left: 30px;\n  \n\n} */\n.boxing {\n  background-color: #fafafa;\n  margin-top: 20px;\n  padding: 16px;\n  width: 100%;\n  padding-top: 12px;\n  border: 1px solid #d7d7d7;\n  border-radius: 5px;\n}\n.boxing1 {\n  max-width: 1000px;\n}\n\n.buttonclr {\n  border-radius: 6px;\n  background-color: #f7cd60;\n  align-items: center;\n  width: 170px;\n  height: 32px;\n  border: none;\n  color: white;\n}\n.detail {\n  display: flex;\n}\n.answer {\n  font-weight: bold;\n}\ntextarea {\n  height: 80px;\n  width: 100% !important;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  font-size: medium;\n}\ntextarea::placeholder {\n  padding: 5px;\n}\n.truncate-text::after {\n  content: \"...\";\n}\n\n.myCustomList::-webkit-scrollbar {\n  max-width: 8px;\n}\n\n.myCustomList::-webkit-scrollbar-thumb {\n  background: rgba(190, 137, 118, 0.4);\n  border-radius: 10px;\n}\n\n.MuiBadge-colorPrimary {\n  color: white !important;\n  background-color: #be8976 !important;\n  padding: 2px 2px !important;\n  font-size: 10.3px !important;\n}\n\n.tool-tip {\n  position: relative;\n  display: inline-block;\n}\n\n.tool-tip-delay {\n  position: relative;\n  display: inline-block;\n}\n\n.tool-tip-delay .tooltip-text-delay {\n  visibility: hidden;\n  width: max-content;\n  background-color: #e9d2c9;\n  color: #363157;\n  text-align: center;\n  border-radius: 3px;\n  padding: 5px 10px;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n  transform: translate(-50%, 50%);\n  top: 22px;\n  left: 55px;\n}\n\nspan.tooltip-text-delay::before {\n  width: 0px;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #e9d2c9;\n  content: \"\";\n  position: absolute;\n  top: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.tool-tip-delay:hover .tooltip-text-delay {\n  visibility: visible;\n}\n\n.tool-tip-delay .tooltip-graph {\n  transform: translate(0);\n  position: fixed;\n  right: 0px;\n  left: 0px;\n  top: 30px;\n  z-index: 9999;\n  width: 75%;\n}\n\n.circle-line\n{\n  top: 15px;\n  width: 2px;\n  background: rgb(211, 218, 230);\n  height: calc(100% + 24px);\n  position: absolute;\n  left: 17px;\n}\n\ndiv.checking:last-of-type {\n  height: 50% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
